import * as React from 'react';
import { Spinner } from 'office-ui-fabric-react';

import styles from './ButtonSpinner.module.scss';

export const ButtonSpinner = () => <Spinner className={styles.buttonSpinner} />;
